import { capitalizeStringUtil } from 'packages/src'
import {
  getCountKeySetDataUtil,
  getCountValueLabelSetUtil,
  WEIGHT_UNIT_MESSAGE
} from '@gymaholic/packages'
import ChipButtonSelect from 'components/ChipButtonSelect/index.js'
import formatMessageIntlUtil from 'modules/intl/utils/format-message'
import workoutMessages from 'modules/workout/redux/messages'
import React from 'react'
import useIntl from 'modules/component/utils/hooks/useIntl'
import { logEventAnalyticsUtil } from 'modules/analytics/utils/log-event/index.js'
import { View } from 'components/View.js'

const ANALYTIC_EVENT = {
  VIEW_EXERCISE_FROM_SET_ROW: 'VIEW_EXERCISE_FROM_SET_ROW'
}

export default function SetRowButtons ({
  setData,
  isRest,
  isSelected,
  handleClickSetValue,
  handleClickSetType,
  handleClickWeight
}) {
  const intl = useIntl()

  if (!setData) {
    return null
  }

  const key = getCountKeySetDataUtil(setData)

  const renderTimeRepsRest = () => {
    const handleClick = (event) => {
      event.stopPropagation()
      handleClickSetValue?.(event)
    }

    return (
      <ChipButtonSelect
        title={getCountValueLabelSetUtil(key, setData[key])}
        onClick={handleClick}
        disabled={!isSelected}
        showArrow={!!handleClickSetValue}
      />
    )
  }

  const renderType = () => {
    if (isRest) {
      return null
    }

    const handleClick = (event) => {
      event.stopPropagation()
      handleClickSetType?.(event)
    }

    return (
      <ChipButtonSelect
        title={capitalizeStringUtil(key)}
        onClick={handleClick}
        disabled={!isSelected}
        showArrow={!!handleClickSetType}
      />
    )
  }

  const renderEquipment = () => {
    if (isRest) {
      return null
    }

    let text = ''
    if (setData.weight) {
      text = `${setData.weight} ${formatMessageIntlUtil(
        intl,
        WEIGHT_UNIT_MESSAGE[setData.weightUnit]
      )}`
    } else {
      text = formatMessageIntlUtil(intl, workoutMessages.noEquipment)
    }

    const handleClick = (event) => {
      logEventAnalyticsUtil(ANALYTIC_EVENT.VIEW_EXERCISE_FROM_SET_ROW)
      event.stopPropagation()
      handleClickWeight?.(event)
    }

    return (
      <ChipButtonSelect
        title={text}
        onClick={handleClick}
        disabled={!isSelected}
        showArrow={!!handleClickWeight}
        style={{
          marginRight: 0
        }}
      />
    )
  }

  return (
    <View
      row
      mt
    >
      {renderTimeRepsRest()}
      {renderType()}
      {renderEquipment()}
    </View>
  )
}
